import { MouseEvent } from 'react';
import styled from 'styled-components';

// Inline "Delete? Yes / No" confirmation used by both session rows and
// folder rows (replaces the ellipsis button while confirming).
export default function ConfirmDelete({
  onConfirm,
  onCancel,
}: {
  readonly onConfirm: (e: MouseEvent) => void;
  readonly onCancel: (e: MouseEvent) => void;
}) {
  return (
    <ConfirmRow>
      <ConfirmText>Delete?</ConfirmText>
      <ConfirmButton type="button" onClick={onConfirm}>
        Yes
      </ConfirmButton>
      <ConfirmCancel type="button" onClick={onCancel}>
        No
      </ConfirmCancel>
    </ConfirmRow>
  );
}

const ConfirmRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const ConfirmText = styled.span`
  color: var(--text-secondary);
  font-size: 10px;
  margin-right: 2px;
`;

const ConfirmButton = styled.button`
  border: 1px solid var(--error-color, #e3415a);
  background: transparent;
  color: var(--error-color, #e3415a);
  font-size: 10px;
  font-weight: 600;
  padding: 2px 14px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: var(--error-color, #e3415a);
    color: var(--cta-text-color, #090a0a);
  }
`;

const ConfirmCancel = styled.button`
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-secondary);
  font-size: 10px;
  padding: 2px 14px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: var(--text-primary);
  }
`;
